import { IVectorPropertyEditable, instanceOfIVectorPropertyEditable } from "./IVectorPropertyEditable";
import { ILocationPropertyPresentable, instanceOfILocationPropertyPresentable } from "./ILocationPropertyPresentable";
import { ISizePropertyPresentable, instanceOfISizePropertyPresentable } from "./ISizePropertyPresentable";
import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IPoint } from "../../../../base/domain/drawing";

export interface IVectorCoordinateEditable extends IVectorPropertyEditable, ILocationPropertyPresentable, ISizePropertyPresentable {
  from(): IPropertyEditable<IPoint>;
  to(): IPropertyEditable<IPoint>;
}

export function instanceOfIVectorCoordinateEditable(instance: any): instance is IVectorCoordinateEditable {
  return instanceOfIVectorPropertyEditable(instance)
      && instanceOfILocationPropertyPresentable(instance)
      && instanceOfISizePropertyPresentable(instance);
}
